/**
 * The board's right-click menu: first what the GUI packs taking part offer for the selection
 * (UI/UX's: component, instance and the prototype's start), then a note or a frame there, and
 * what the selection can do; always the export of a picture.
 */
import type { MenuEntry } from "../../../shared/menus";
import type { Board, Point } from "../../../state/board";
import type { Packs } from "../../../state/packs";

/** The board's entries for a right click at `at` (board units); `write` starts writing a new note's words. */
export function boardMenu(board: Board, packs: Pick<Packs, "boardMenu">, at: Point, canEdit: boolean, write: (id: string) => void): MenuEntry[] {
  const any = board.selected().length > 0;
  const entries: MenuEntry[] = canEdit
    ? [
        ...packs.boardMenu(at, canEdit),
        { label: "Sticky note here", action: () => void board.create(board.toolFor("note"), { ...at, w: 0, h: 0 }).then((made) => made && write(made)) },
        { label: board.frames()?.here ?? "Frame here", action: () => void board.create("frame", { x: at.x, y: at.y, w: 0, h: 0 }) },
        ...(any
          ? [
              { label: "Duplicate", command: "board.duplicate" },
              { label: "Group", command: "board.group", disabled: board.selected().length < 2 },
              { label: "Ungroup", command: "board.ungroup" },
              { label: "Bring to front", command: "board.front" },
              { label: "Send to back", command: "board.back" },
              { label: "Delete", command: "selection.delete", danger: true },
            ]
          : []),
      ]
    : [];
  return [...entries, { label: any ? "Export the selection as an image…" : "Export the board as an image…", command: "board.export" }];
}
